import { createStylesMap } from 'app/theme/materialTheme';

export const styles = createStylesMap({
  button: (theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }),
});
